// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  //  apiUrl: 'http://tarek007-001-site3.ktempurl.com',
  //apiUrl: 'http://aligntech2022-001-site1.ktempurl.com', // Facility Management Base URL
  apiUrl:"http://aligntech2022-001-site4.ktempurl.com", //Admin Tool Base URL
  aiAppUrl: 'https://aligntech2022-001-site12.etempurl.com',
  centralAiApiUrl: 'https://aligntech2022-001-site11.etempurl.com',
  centralAiIntegrationUserName: 'Integration',
  centralAiIntegrationPassword: '123456',
  firebase: {
    apiKey: "AIzaSyCsFeMUlnNGOT7TuHQx4bxUzsIrPyIEH7A",
    authDomain: "facility-management-b729d.firebaseapp.com",
    projectId: "facility-management-b729d",
    storageBucket: "facility-management-b729d.appspot.com",
    messagingSenderId: "182480860179",
    appId: "1:182480860179:web:71e495db787b6221457be6",
    measurementId: "G-8BLDJ70F71"
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
